import { USER_LOGGED_IN, USER_LOGGED_IN_ERROR, USER_LOGOUT, USER_TOKEN_EXPIRED } from '../../actions/user_actions';

export default function(state = null, action){
    switch (action.type){
        case USER_LOGGED_IN:
            let user = action.payload;
            user['token_date'] = new Date().getTime();
            localStorage.setItem('activeUser', JSON.stringify(user));
            return user;
        case USER_LOGGED_IN_ERROR:
            return {username: null};
        case USER_LOGOUT:
        case USER_TOKEN_EXPIRED:
            localStorage.clear();
            break;
        default:
            break;
    }

    const data = localStorage.getItem('activeUser');
    if(data){
        return JSON.parse(data);
    }

    return null;
}



// WEBPACK FOOTER //
// ./src/reducers/user/reducer_user.js